import { render, staticRenderFns } from "./PlayersFilterDesktop.vue?vue&type=template&id=661a5b56&scoped=true&"
import script from "./PlayersFilterDesktop.vue?vue&type=script&lang=js&"
export * from "./PlayersFilterDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PlayersFilterDesktop.vue?vue&type=style&index=0&id=661a5b56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a5b56",
  null
  
)

export default component.exports